/* eslint-disable @typescript-eslint/no-explicit-any */
import { type searchParam } from '@/hooks/useCategoryHook'
import { type Property } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { getPath } from '@/utils/next-util'
import { Disclosure, Transition } from '@headlessui/react'
import { useState, type Dispatch, type SetStateAction } from 'react'
import { FilterGroup } from './FilterGroup'

export interface FilterList {
  className?: string
  filterGroup: Property
  title?: string
  currentFilter?: searchParam[]
  setCurrentFilter?: Dispatch<SetStateAction<searchParam[]>>
  onChange: (params: any, routerChange?: boolean) => void
  activeFilters: {
    name: string
    values: string[]
  }[]
}

export const FilterList = ({
  title,
  className,
  filterGroup,
  activeFilters = [],
  onChange = () => true,
}: FilterList) => {
  const [isReadMore, setIsReadMore] = useState(true)
  const [isPropertyFilter, setIsPropertyFilter] = useState(8)

  const toggleReadMore = () => {
    setIsPropertyFilter(isReadMore ? 99 : 8)
    setIsReadMore(!isReadMore)
  }

  return (
    <div className={`${className ? className : ''}`}>
      <Disclosure defaultOpen={true}>
        {({ open }) => (
          <>
            <Disclosure.Button>
              <span className='text-sm font-bold text-dark-400'>{title}</span>
            </Disclosure.Button>
            <Transition
              show={open}
              enter='transition duration-100 ease-out'
              enterFrom='transform scale-95 opacity-0'
              enterTo='transform scale-100 opacity-100'
              leave='transition duration-75 ease-out'
              leaveFrom='transform scale-100 opacity-100'
              leaveTo='transform scale-95 opacity-0'
            >
              <Disclosure.Panel className={'mt-1'}>
                <div
                  className={`filterContent grid h-full grid-cols-2 gap-x-2 items-start overflow-hidden `}
                >
                  {filterGroup.values.length > 0 &&
                    filterGroup.values
                      .slice(0, isPropertyFilter)
                      .map((t, index) => (
                        <FilterGroup
                          type='checkbox'
                          className='mb-1'
                          key={`group-${index}`}
                          option={t}
                          activeOption={activeFilters.find(
                            (f: any) => f.name === getPath(filterGroup.slugs)
                          )}
                          onChange={e => onChange(e, false)}
                        >
                          <span className='block h-full align-super text-sm text-dark-400'>
                            {getTranslate(t.value)}
                          </span>
                        </FilterGroup>
                      ))}
                </div>
                {filterGroup.values.length > 8 && (
                  <span
                    onClick={toggleReadMore}
                    className='readOrHide cursor-pointer text-[10px] text-primary-second gap-x-2 flex items-center'
                  >
                    {isReadMore ? 'Hiển thị nhiều hơn' : 'Hiển thị ít hơn'}
                    <svg
                      className={`inline-block origin-center ${
                        !isReadMore ? 'rotate-180' : ''
                      }`}
                      width='16'
                      height='16'
                      viewBox='0 0 16 16'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M7.99992 11.0001C7.73472 11 7.48041 10.8946 7.29292 10.7071L3.29292 6.70708C3.11076 6.51848 3.00997 6.26588 3.01224 6.00368C3.01452 5.74148 3.11969 5.49067 3.3051 5.30526C3.49051 5.11985 3.74132 5.01469 4.00352 5.01241C4.26571 5.01013 4.51832 5.11092 4.70692 5.29308L7.99992 8.58608L11.2929 5.29308C11.3852 5.19757 11.4955 5.12139 11.6175 5.06898C11.7395 5.01657 11.8707 4.98898 12.0035 4.98783C12.1363 4.98668 12.268 5.01198 12.3909 5.06226C12.5138 5.11254 12.6254 5.18679 12.7193 5.28069C12.8132 5.37458 12.8875 5.48623 12.9377 5.60913C12.988 5.73202 13.0133 5.8637 13.0122 5.99648C13.011 6.12926 12.9834 6.26048 12.931 6.38249C12.8786 6.50449 12.8024 6.61483 12.7069 6.70708L8.70692 10.7071C8.51943 10.8946 8.26511 11 7.99992 11.0001Z'
                        fill='#00C1D5'
                      />
                    </svg>
                  </span>
                )}
              </Disclosure.Panel>
            </Transition>
          </>
        )}
      </Disclosure>
    </div>
  )
}
